document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("custom-inquiry-btn");
  const popup = document.getElementById("customFormPopup");
  const closeBtn = document.getElementById("closeCustomFormBtn");
  const productNameField = document.getElementById("productNameField");
  let form = null;
  if (popup) {
    form = popup.querySelector("form");

    // Open the popup and autofill product name
    openBtn.addEventListener("click", function () {
      popup.style.display = "flex";
      jQuery("body").addClass("active_pop");
      // Reset form before opening
      form.reset();

      const title = document.querySelector(".product__title h1");
      if (title) {
        productNameField.value = title.textContent.trim();
      }
      const popupBox = document.querySelector(".popup-box");
      if (popupBox) {
        const offsetTop =
          popupBox.getBoundingClientRect().top + window.pageYOffset - 150;
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
    });

    // Close popup when clicking the close button
    closeBtn.addEventListener("click", function () {
      popup.style.display = "none";
      jQuery("body").removeClass("active_pop");
    });

    // Close popup if clicked outside the form box
    window.addEventListener("click", function (e) {
      if (e.target === popup) {
        popup.style.display = "none";
        jQuery("body").removeClass("active_pop");
      }
    });

    // On form submit
    form.addEventListener("submit", function (e) {
      setTimeout(() => {
        form.reset();
        popup.style.display = "none";
        jQuery("body").removeClass("active_pop");
      }, 5000);
    });
  }
  // Wrap quantity
  jQuery(".product-form__quantity").each(function () {
    var $this = $(this);
    var $next = $this.next();
    var $btn = jQuery(
      `<div class="wishlist_btns"><img src="https://cdn.shopify.com/s/files/1/0577/8027/3210/files/delta.svg?v=1748966602"></div>`
    );
    $this
      .add($next)
      .add($btn)
      .wrapAll('<div class="wwdelta_qty_wrapper"></div>');
  });

  jQuery(document).on("click", ".wishlist_btns", function (e) {
    jQuery(".koh-wishlist-btn").trigger("click");
  });

  // Enable add to cart button on variant selection
  document.querySelectorAll(".single-option-form").forEach(function (form) {
    const radios = form.querySelectorAll('input[type="radio"]');
    const button = form.querySelector(".add-to-cart-btn");

    radios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        if (button) button.disabled = false;
      });
    });
  });

  // Wrap review and inventory
  const reviewBadge = document.getElementById(
    "shopify-block-AN2FweGJwdjk4WXNkW__judge_me_reviews_preview_badge_GfbakM"
  );
  const inventory = document.querySelector(".product__inventory");

  if (reviewBadge && inventory) {
    const wrapper = document.createElement("div");
    wrapper.className = "wwcrop_wrapper_rit";
    reviewBadge.parentNode.insertBefore(wrapper, reviewBadge);
    wrapper.appendChild(reviewBadge);
    wrapper.appendChild(inventory);
  }
}); // ✅ this was previously prematurely closed

// jQuery DOM Ready
jQuery(window).on("load", function () {
  jQuery(document).on("click", ".wishlist-btn", function () {
    console.log("fwf");

    const $this = jQuery(this);
    const variantId = parseInt($this.data("variant-id"));
    const productId = parseInt($this.data("product-id"));
    const handle = $this.data("handle");
    const title = $this.data("title");
    const image = $this.data("image");
    const description = $this.data("description");

    const productUrl = `/products/${handle}?variant=${variantId}`;
    const productTitle = title.replace(/ - .*$/, ""); // Remove variant size from title

    // Construct wishlist item
    const itemToAdd = {
      id: variantId,
      variant: {
        id: variantId,
        title: title,
        variant_id: variantId,
        product_id: productId,
        url: productUrl,
        image: image,
        handle: handle,
        product_title: productTitle,
        product_description: description,
      },
      wishList: "koh",
    };

    // Get existing wishlist
    const existingRaw = localStorage.getItem("koh-products");
    const wishlist = existingRaw ? JSON.parse(existingRaw) : [];

    // Check if already exists
    const alreadyExists = wishlist.some((item) => item.id === variantId);

    if (!alreadyExists) {
      wishlist.push(itemToAdd);
      localStorage.setItem("koh-products", JSON.stringify(wishlist));
    }

    // Trigger menu click after a short delay
    setTimeout(function () {
      const $menuBtn = jQuery(".koh-menu-btn");
      if ($menuBtn.length) {
        $menuBtn.trigger("click");
      } else {
        console.warn("koh-menu-btn not found");
      }
    }, 1000);
  });
});

jQuery(document).ready(function ($) {
  $(".wwimi_delta_product").closest("section").addClass("wwimi_prp");

  let clickTimeout;

  $(".play_video_btn").on("click", function () {
    const video = $(this).closest(".wwicic_video_wrapper").find("video").get(0);

    if (clickTimeout !== undefined) {
      clearTimeout(clickTimeout);
      clickTimeout = undefined;
      video.pause();
      video.muted = true;
    } else {
      clickTimeout = setTimeout(() => {
        video.muted = false;
        video.play();
        clickTimeout = undefined;
      }, 250);
    }
  });

  $(".wwicic_text_testimonial_slider").owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 4000,
    smartSpeed: 600,
    navText: [
      '<span class="nav-btn prev-slide"><img src="https://cdn.shopify.com/s/files/1/0577/8027/3210/files/left_side.svg?v=1745258395"/></span>',
      '<span class="nav-btn next-slide"><img src="https://cdn.shopify.com/s/files/1/0577/8027/3210/files/right-side.svg?v=1745258395"/></span>',
    ],
    responsive: {
      0: { items: 1 },
      768: { items: 2 },
      1024: { items: 4 },
    },
  });

  $(".wwici_testimonial__video_slider").owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    margin: 20,
    autoplay: true,
    autoplayTimeout: 4000,
    smartSpeed: 600,
    navText: [
      '<span class="nav-btn prev-slide"><img src="https://cdn.shopify.com/s/files/1/0577/8027/3210/files/left_side.svg?v=1745258395"/></span>',
      '<span class="nav-btn next-slide"><img src="https://cdn.shopify.com/s/files/1/0577/8027/3210/files/right-side.svg?v=1745258395"/></span>',
    ],
    responsive: {
      0: { items: 1 },
      768: { items: 2 },
      1024: { items: 4 },
    },
  });

  $(".wwici_testimonial__video_slider .owl-stage").on(
    "mouseenter",
    function () {
      $(".wwici_testimonial__video_slider").trigger("stop.owl.autoplay");
    }
  );

  $(".wwici_testimonial__video_slider .owl-stage").on(
    "mouseleave",
    function () {
      $(".wwici_testimonial__video_slider").trigger("play.owl.autoplay", [
        4000,
      ]);
    }
  );

  $(".wwici_mission__iwrapper").owlCarousel({
    loop: false,
    margin: 20,
    nav: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    navText: [
      '<span class="nav-btn prev-slide"><img src="https://cdn.shopify.com/s/files/1/0577/8027/3210/files/left_side.svg?v=1745258395"/></span>',
      '<span class="nav-btn next-slide"><img src="https://cdn.shopify.com/s/files/1/0577/8027/3210/files/right-side.svg?v=1745258395"/></span>',
    ],
    responsive: {
      0: { items: 1 },
      768: { items: 2 },
      1024: { items: 3 },
    },
  });

  $(".hero-slider").owlCarousel({
    items: 1,
    loop: false,
    nav: false,
    dots: true,
  });

  function waitForKOH(callback) {
    const interval = setInterval(() => {
      if (window.KOH && typeof window.KOH.getProducts === "function") {
        clearInterval(interval);
        callback();
      }
    }, 100);
  }

  waitForKOH(() => {
    function isInWishlist(productId) {
      const products = window.KOH.getProducts() || [];
      return products.some((p) => p.product_id == productId);
    }

    function refreshHearts() {
      $(".wishlist-btn").each(function () {
        const productId = $(this).data("product-id");
        const heart = $(this).find(".heart-icon");
        if (isInWishlist(productId)) {
          heart.text("♥"); // Filled heart
        } else {
          heart.text("♡"); // Empty heart
        }
      });
    }

    // Add to Wishlist on click
    $(".wishlist-btn").on("click", function (event) {
      event.stopPropagation();

      const button = $(this);
      const productId = button.data("product-id");
      const variantId = button.data("variant-id");
      const heart = button.find(".heart-icon");

      const products = window.KOH.getProducts() || [];
      const isAlreadySaved = products.some((p) => p.product_id == productId);

      if (isAlreadySaved) {
        window.KOH.removeProduct(productId);
      } else {
        window.KOH.addProduct({ product_id: productId, variant_id: variantId });
      }

      setTimeout(refreshHearts, 200);
    });

    // Initial heart rendering
    refreshHearts();
  });
});
